import { Tag, TagProps, Tooltip, TooltipProps } from '@optimus-web/core';

export type TooltippedTagProps = TagProps & Partial<TooltipProps>;

export const TooltippedTag = Tooltip(Tag) as React.ComponentType<TooltippedTagProps>;
